import {
  EnumCambiamentoStatoRequestTransizione,
  getGetFrontRichiesteIdModuliIdQueryKey,
  getGetFrontRichiesteIdModuliQueryKey,
  usePostFrontRichiesteIdModuliIdStato,
} from '@framework/api-client';
import { getNetworkErrorMessage } from '@framework/auth';
import {
  IModuleStateMachineRecord,
  focusOnSubmissionTitle,
} from '@framework/frontoffice-submission';
import { useTranslation } from '@framework/i18n';
import { message } from 'antd';
import { useCallback } from 'react';
import { queryClient } from '../../../../../core/network/queryClient';

export function useSubmissionModuleStateChanger(params: {
  data: IModuleStateMachineRecord;
  /** Se non fornito, non mostra il messaggio */
  successMessage: string | null;
}) {
  const { data, successMessage } = params;
  const { t } = useTranslation();

  const stateChanger = usePostFrontRichiesteIdModuliIdStato();
  const submissionModuleId = data.module?.moduloRichiestaId;
  const submissionId = data.submission?.id;

  const handleClick = useCallback(
    async (
      toState: EnumCambiamentoStatoRequestTransizione,
      options?: {
        /** Se true, le query non vengono invalidate dopo il passaggio di stato */
        mantainQueries?: boolean;
      },
    ) => {
      if (!submissionModuleId) return;
      if (!submissionId) return;

      try {
        await stateChanger.mutateAsync({
          id: submissionId,
          idRichiestaModulo: submissionModuleId,
          data: {
            transizione: toState,
          },
        });
        if (!options?.mantainQueries) {
          await queryClient.invalidateQueries(
            getGetFrontRichiesteIdModuliIdQueryKey(
              submissionId,
              submissionModuleId,
            ),
          );

          await queryClient.invalidateQueries(
            getGetFrontRichiesteIdModuliQueryKey(submissionId),
          );
        }

        successMessage && message.success(successMessage);
        // per accessibilità spostiamo il focus sul titolo del modulo
        focusOnSubmissionTitle();
      } catch (e) {
        console.error(`[ReadyToSignButton] Error while changing state`, e); // prettier-ignore
        message.error(getNetworkErrorMessage(e, t('submission-action-button.errore', `Si è verificato un errore: riprovare`))); // prettier-ignore
      }
    },
    [submissionModuleId, submissionId, stateChanger, successMessage],
  );

  return {
    handleClick,
  };
}
